import { Modal } from "react-bootstrap"
import { useMutation } from "react-query"
import { toast } from "react-toastify"

import { updateRJQuestion } from "../../../../../models/courses/courses"
import RJQuestionForm from "./RJQuestionForm"


const EditRJQuestionModal = ({ queryClient, lesson, question, show, onHide }) => {
    const { mutate, isLoading } = useMutation(data => updateRJQuestion(lesson.course_id, lesson.section_id, lesson.id, question.id, data), {
        onSuccess: () => {
            toast.success('Success')
            queryClient.invalidateQueries([`lessons-${lesson.id}-questions`])
            onHide()
        },
        onError: error => toast.error(error?.response?.data?.message || error.message)
    })

    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit Question</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="rounded border p-3 bg-light-primary">
                    <p className="mb-0 fw-semibold">{lesson?.title}</p>
                </div>
                <div className="separator my-6"></div>
                <RJQuestionForm queryClient={queryClient} lesson={lesson} data={question} onSubmit={data => mutate(data)} submitLoading={isLoading} />
            </Modal.Body>
        </Modal>
    )
}

export default EditRJQuestionModal